// extracted by css-extract-rspack-plugin
export default {"link":"_2fdd354b","respTitle":"_d99e3b5f","respDescription":"_8d878f9","consumerBg":"_d9bdd670","tradeBg":"_92a96a88","mobileImage":"_945f6e2c","tradeButton":"_d0a7563b"};